const SyncStatus = {
  SOCKET: 'socket',
  DISCONNECTED: 'disconnected',
};

export default SyncStatus;
